import { axiosGetHandler, axiosPostHandler } from '../config';

// 获取活动数据
export function getData(args) {
  let url = '/game/h5_activity/data';
  return axiosGetHandler(url, args);
}

export function vote(args) {
  let url = '/game/h5_activity/vote';
  return axiosGetHandler(url, args);
}

export function getActivityInfo() {
  let url = '/game/tga/2024/info/';
  return axiosGetHandler(url);
}
export function receiveAvatarFrame(args, formdata = {}) {
  let url = '/game/tga/2024/receive/';
  return axiosPostHandler(url, args, formdata);
}

export function getChatMessage(args) {
  let url = '/chatroom/v2/channel_msg/list';
  return axiosGetHandler(url, args);
}

export function getSubscribeState(args) {
  let url = '/game/tga/2024/info/'
  return axiosGetHandler(url, args);
}

export function subscribePush(args, formdata) {
  let url = '/game/tga/2024/change_push_state/'
  return axiosPostHandler(url, args, formdata);
}

export function getCeremonyInfo(args) {
  let url = '/game/tga/2024/end_publish_info/'
  return axiosGetHandler(url, args);
}

export function follow(args, formData) {
  let url = '/bbs/app/profile/follow/user'
  return axiosPostHandler(url, args, formData);
}

export function cancelFollow(args, formData) {
  let url = '/bbs/app/profile/follow/user/cancel'
  return axiosPostHandler(url, args, formData);
}


export function getFontFile(args, formData) {
  var url = `${window.$WEB_HOST}/tool/get_font_file`;
  return axiosPostHandler(url, args, formData);
}

// 取消关注游戏
export function unFollowGame (args, formData) {
  let url = '/account/web/unfollow_game';
  return axiosPostHandler(url, args, formData);
}

// 关注游戏
export function followGame (args, formData) {
  let url = '/account/web/follow_game';
  return axiosPostHandler(url, args, formData);
}